import applyPendingRoleCapabilityPatches from '@/lib/settings/rolePermissions/applyPendingRoleCapabilityPatches.js';
import mergeCapabilityLayers from '@shared/pieve/mergeCapabilityLayers.js';

const buildRoleCapabilityVisiblePayload = ({ serverPayload, pendingMutations, fallbackRoleId } = {}) => {
  const currentServerPayload = serverPayload && typeof serverPayload === 'object' ? serverPayload : null;
  const nextCapabilities = applyPendingRoleCapabilityPatches({
    capabilities: currentServerPayload?.capabilities || {},
    pendingMutations
  });
  const nextResolvedCapabilities = mergeCapabilityLayers({
    roleBlob: nextCapabilities,
    userBlob: null
  });

  if (!currentServerPayload && !fallbackRoleId && Object.keys(nextCapabilities).length < 1) {
    return null;
  }

  return {
    ...(currentServerPayload || {}),
    role: currentServerPayload?.role || (fallbackRoleId ? { id: fallbackRoleId } : null),
    capabilities: nextCapabilities,
    resolvedCapabilities: nextResolvedCapabilities
  };
};

export default buildRoleCapabilityVisiblePayload;
